import ProductVideo from "./ProductVideo";
import { products } from "@/mocks/products";

const steps = [
  {
    icon: "ri-image-line",
    title: "Foto original",
    text: "Tudo começa com a foto que você já tem do prato.",
  },
  {
    icon: "ri-sparkling-line",
    title: "Inteligência Artificial",
    text: "O Play Menu analisa e prepara a transformação.",
  },
  {
    icon: "ri-video-line",
    title: "O prato ganha movimento",
    text: "Textura, vapor, brilho e aquele clima que dá fome.",
  },
  {
    icon: "ri-smartphone-line",
    title: "Entra no cardápio",
    text: "O vídeo entra automaticamente no seu Play Menu.",
  },
];

export default function Transformation() {
  const dish = products[0];
  // Vídeo de demonstração da transformação (hambúrguer sendo partido ao meio).
  const transformationVideo =
    "https://storage.helloreaddy.io/project_files/52886a64-7fa9-42b2-a5b3-49fd386bb6d3/8e4c57e7-ff6c-49a1-833c-458a361b7040_Hamburguer_sendo_partido_ao_meio_20260916164112.mp4";

  return (
    <section
      id="transformacao"
      className="grain relative overflow-hidden bg-foreground-950 py-24 md:py-32"
    >
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_50%_20%,oklch(var(--primary-500)/0.16),transparent_60%)]" />

      <div className="relative z-10 mx-auto max-w-6xl px-4 md:px-6">
        <div className="reveal mx-auto max-w-3xl text-center">
          <span className="mb-5 inline-flex items-center gap-2 text-xs font-bold uppercase tracking-[0.2em] text-accent-500">
            <span className="h-px w-6 bg-current" />
            Veja a transformação
            <span className="h-px w-6 bg-current" />
          </span>
          <h2 className="font-heading text-4xl font-bold leading-[1.05] tracking-tight text-foreground-50 md:text-6xl">
            De uma foto para{" "}
            <span className="text-primary-500">uma experiência.</span>
          </h2>
        </div>

        {/* Antes → Depois em movimento */}
        <div className="mt-16 flex flex-col items-center">
          <div className="reveal relative mx-auto w-full max-w-[320px] md:max-w-[360px]">
            <div className="absolute -inset-6 -z-10 rounded-[2.5rem] bg-primary-500/20 blur-3xl" />
            <div className="overflow-hidden rounded-[1.6rem] border border-foreground-700/50 bg-foreground-900">
              <div className="aspect-[4/5]">
                <ProductVideo src={transformationVideo} poster={dish.image} alt={dish.name} />
              </div>
            </div>
            <span className="absolute left-4 top-4 rounded-full bg-foreground-950/80 px-3 py-1 text-[10px] font-bold uppercase tracking-widest text-foreground-200 backdrop-blur">
              Antes: uma foto
            </span>
            <span className="absolute bottom-4 right-4 rounded-full bg-primary-500 px-3 py-1 text-[10px] font-bold uppercase tracking-widest text-foreground-950">
              Depois: desejo
            </span>
          </div>

          <p className="reveal mt-8 max-w-md text-center text-sm leading-relaxed text-foreground-400">
            Role e veja a foto parada ganhar movimento. É assim que o cliente
            passa a enxergar o seu prato.
          </p>
        </div>

        {/* 4 passos */}
        <div className="mt-16 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4 md:mt-20">
          {steps.map((step, i) => (
            <div
              key={step.title}
              className="reveal relative flex flex-col gap-4 rounded-2xl border border-foreground-800/60 bg-secondary-500/20 p-6"
              style={{ transitionDelay: `${i * 80}ms` }}
            >
              <span className="font-heading text-3xl font-bold text-primary-500/30">
                {String(i + 1).padStart(2, "0")}
              </span>
              <span className="flex h-12 w-12 items-center justify-center rounded-xl bg-primary-500/15 text-primary-500">
                <i className={`${step.icon} text-2xl`} aria-hidden="true" />
              </span>
              <h3 className="font-heading text-base font-bold leading-snug text-foreground-50">
                {step.title}
              </h3>
              <p className="text-sm leading-relaxed text-foreground-400">
                {step.text}
              </p>
            </div>
          ))}
        </div>

        <div className="mt-14 flex justify-center">
          <a
            href="https://playmenu.app/cadastro?tipo=restaurante"
            target="_blank"
            rel="noopener"
            className="inline-flex items-center justify-center whitespace-nowrap rounded-full bg-primary-500 px-9 py-4 text-base font-semibold text-foreground-950 transition-all hover:bg-primary-400 hover:scale-[1.02]"
          >
            Quero testar com meus produtos
            <i className="ri-arrow-right-line ml-2 text-lg" aria-hidden="true" />
          </a>
        </div>
      </div>
    </section>
  );
}